import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { blogPosts } from '../data/mock';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { useState, useEffect } from "react";

const Blog = () => {
  const [selectedPost, setSelectedPost] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-[#0B0F14] min-h-screen">
      <Navbar />


      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center space-y-4">
          <h1 className="text-5xl lg:text-6xl font-bold text-white font-['Qurova',sans-serif]">
            AI <span className="text-[#3DF2E0]">Insights</span>
          </h1>
          <p className="text-xl text-[#9CA3AF] font-['League_Spartan'] max-w-2xl mx-auto">
            Latest trends, insights, and best practices in AI automation and business transformation
          </p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="pb-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-[#0B0F14] border border-[#1F2933] rounded-md overflow-hidden hover:border-[#3DF2E0] transition-all duration-300 group">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Image */}
              <div className="h-64 lg:h-auto relative overflow-hidden">
                <img
                  src={blogPosts[0].image}
                  alt={blogPosts[0].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="text-xs font-['JetBrains_Mono',monospace] text-[#0B0F14] bg-[#3DF2E0] px-3 py-1 rounded">
                    Featured
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center space-x-4 mb-4">
                  <span className="text-xs font-['JetBrains_Mono',monospace] text-[#3DF2E0] bg-[#3DF2E0]/10 px-3 py-1 rounded border border-[#3DF2E0]/30">
                    {blogPosts[0].category}
                  </span>
                  <div className="flex items-center text-base text-[#9CA3AF] font-['League_Spartan']">
                    <Clock className="w-4 h-4 mr-1" />
                    {blogPosts[0].readTime}
                  </div>
                </div>

                <h2 className="text-3xl font-bold text-white font-['League_Spartan',sans-serif] mb-4 group-hover:text-[#3DF2E0] transition-colors duration-300">
                  {blogPosts[0].title}
                </h2>

                <p className="text-[#9CA3AF] text-lg font-['League_Spartan'] mb-6 leading-relaxed">
                  {blogPosts[0].excerpt}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center text-base text-[#9CA3AF] font-['League_Spartan']">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(blogPosts[0].date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                  <button onClick={() => setSelectedPost(blogPosts[0])} className="flex items-center text-lg text-[#3DF2E0] font-['League_Spartan'] text-sm group-hover:translate-x-2 transition-transform duration-300">
                    Read More
                    <ArrowRight className="w-4 h-4 ml-2" />

                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-2xl font-bold text-white font-['Qurova',sans-serif] mb-8">
            Recent Articles
          </h3>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.slice(1).map((post) => (
              <div
                key={post.id}
                onClick={() => setSelectedPost(post)}
                className="bg-[#0B0F14] border border-[#1F2933] rounded-md overflow-hidden hover:border-[#3DF2E0] transition-all duration-300 group cursor-pointer"
                style={{
                  boxShadow: '0 0 0 rgba(61, 242, 224, 0)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 0 15px rgba(61, 242, 224, 0.35)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 0 0 rgba(61, 242, 224, 0)';
                }}
              >
                {/* Image */}
                <div className="h-48 relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* Content */}
                <div className="p-6 space-y-4">
                  <div className="flex items-center space-x-3">
                    <span className="text-xs font-['JetBrains_Mono',monospace] text-[#3DF2E0] bg-[#3DF2E0]/10 px-2 py-1 rounded border border-[#3DF2E0]/30">
                      {post.category}
                    </span>
                    <div className="flex items-center text-sm text-[#9CA3AF] font-['League_Spartan']">
                      <Clock className="w-3 h-3 mr-1" />
                      {post.readTime}
                    </div>
                  </div>

                  <h3 className="text-xl font-semibold text-white font-['League_Spartan',sans-serif] group-hover:text-[#3DF2E0] transition-colors duration-300">
                    {post.title}
                  </h3>

                  <p className="text-base text-[#9CA3AF] font-['League_Spartan'] leading-relaxed">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between pt-4 border-t border-[#1F2933]">
                    <div className="flex items-center text-sm text-[#9CA3AF] font-['League_Spartan']">
                      <Calendar className="w-3 h-3 mr-1" />
                      {new Date(post.date).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </div>
                    <button className="flex items-center text-base text-[#3DF2E0] font-['League_Spartan'] text-sm group-hover:translate-x-1 transition-transform duration-300">
                      Read
                      <ArrowRight className="w-3 h-3 ml-1" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-[#0B0F14] border border-[#3DF2E0] rounded-md p-12 space-y-6">
            <h2 className="text-3xl font-bold text-white font-['Qurova',sans-serif]">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-[#9CA3AF] font-['League_Spartan']">
              Let's discuss how AI automation can help you scale faster
            </p>
            <Link to="/">
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
                className="bg-[#0B0F14] text-lg text-[#3DF2E0] border-2 border-[#3DF2E0] hover:bg-[#3DF2E0] hover:text-[#0B0F14] transition-all duration-300 rounded-md px-8 py-4 font-['Qurova'] inline-block"
              >
                Book AI Consultation
              </button>
            </Link>
          </div>
        </div>
      </section>

      {selectedPost && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6">

          <div className="bg-[#0B0F14] max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-md border border-[#3DF2E0] relative">

            {/* Close Button */}
            <button
              onClick={() => setSelectedPost(null)}
              className="absolute top-4 right-4 text-white text-xl"
            >
              ✕
            </button>

            {/* Image */}
            <img
              src={selectedPost.image}
              alt={selectedPost.title}
              className="w-full h-64 object-cover"
            />

            {/* Content */}
            <div className="p-6 space-y-4">
              <h2 className="text-3xl font-bold text-white">
                {selectedPost.title}
              </h2>

              <p className="text-sm text-[#9CA3AF]">
                {new Date(selectedPost.date).toDateString()} • {selectedPost.readTime}
              </p>

              <p className="text-[#9CA3AF] leading-relaxed">
                {selectedPost.content || selectedPost.excerpt}
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Blog;
